import { trim } from "lodash";
import validator from "validator";

const useValidations = () => {





const isAvailableError = (fieldNameArray,stateDataObject) =>{


    const errors = {};
    fieldNameArray.map(input => {

        if (!stateDataObject[input] || !trim(stateDataObject[input])) {
  
          return errors[input] = `Please enter your ${input.includes("_") ? input.replace('_id','').split("_").join(" ") : input}.`
        } 

    })
   return errors
   

}
const isMobileNumberError = (fieldNameArray,stateDataObject) =>{

    
    const errors = {};
    fieldNameArray.map(input => {

        if (!stateDataObject[input] || !trim(stateDataObject[input])) {
  
          return errors[input] = `Please enter your ${input.includes("_") ? input.split("_").join(" ") : input}.`
        } else if(!validator.isMobilePhone(`${stateDataObject[input]}`)){
            return errors[input] = `Please enter a valid your ${input.includes("_") ? input.split("_").join(" ") : input}.`

        }

    })
   return errors
   

}
const isValidEmailError = (fieldNameArray,stateDataObject) =>{

    
    const errors = {};
    fieldNameArray.map(input => {

        if (!stateDataObject[input] || !trim(stateDataObject[input])) {
  
          return errors[input] = `Please enter your ${input.includes("_") ? input.split("_").join(" ") : input}.`
        } else if(!validator.isEmail(`${stateDataObject[input]}`)){
            return errors[input] = `Please enter a valid your ${input.includes("_") ? input.split("_").join(" ") : input}.`

        }

    })
   return errors
   

}
const isValidNumberError = (fieldNameArray,stateDataObject) =>{

    
    const errors = {};
    fieldNameArray.map(input => {

        if (stateDataObject[input] && trim(stateDataObject[input])) {
            if (! validator.isNumeric(`${stateDataObject[input]}`)) {
  
                return errors[input] = `Please enter a valid your ${input.includes("_") ? input.split("_").join(" ") : input}.`
              } 

        }

        

    })
   

   return errors
   

}


const isRequiredNumberError = (fieldNameArray,stateDataObject) =>{

    
    const errors = {};
    fieldNameArray.map(input => {
        if (!stateDataObject[input] || !trim(stateDataObject[input])) {
  
          return errors[input] = `Please enter your ${input.includes("_") ? input.split("_").join(" ") : input}.`
        } else if(Number(stateDataObject[input]) =="NaN"){
            return errors[input] = `Please enter a valid your ${input.includes("_") ? input.split("_").join(" ") : input}.`

        }

    })
   return errors
   

}





  return{isAvailableError,isMobileNumberError,isValidNumberError,isRequiredNumberError,isValidEmailError}
}

export default useValidations